module Shared.Zxcvbn

type ZxcvbnList = string list

type PasswordScore = 
    | VeryWeak
    | Weak 
    | SoSo 
    | Good 
    | Excellent 

module PasswordScore =
    let isStrongEnough (minStrength: PasswordScore) score = score >= minStrength

    let toDisplayName = 
        function 
        | VeryWeak -> "Very Weak"
        | Weak -> "Weak"
        | SoSo -> "So So"
        | Good -> "Good"
        | Excellent -> "Excellent"

    let ofInt = 
        function 
        | 1 -> Weak
        | 2 -> SoSo
        | 3 -> Good
        | x when x >= 4 -> Excellent
        | _ -> VeryWeak

    let toInt = 
        function 
        | VeryWeak -> 0 
        | Weak -> 1 
        | SoSo -> 2
        | Good -> 3
        | Excellent -> 4

type PasswordStrengthConfig =
    {
        MinLength: int
        MaxLength: int option
        MinAlpha: int 
        MaxAlpha: int option
        MinNumeric: int
        MaxNumeric: int option
        MinWhitespace: int
        MaxWhitespace: int option
        MinSpecial: int
        MaxSpecial: int option
        MinUpper: int
        MaxUpper: int option
        MinLower: int 
        MaxLower: int option
    }

module PasswordStrengthConfig =
    let defaults =
        {
            MinLength = 0
            MaxLength = None
            MinAlpha = 0
            MaxAlpha = None
            MinNumeric = 0
            MaxNumeric = None
            MinWhitespace = 0
            MaxWhitespace = None
            MinSpecial = 0
            MaxSpecial = None
            MinUpper = 0
            MaxUpper = None
            MinLower = 0
            MaxLower = None
        }

type PasswordConfig = 
    {
        ZxcvbnList: string list 
        MinScore: PasswordScore
        PasswordStrength: PasswordStrengthConfig
    }

module PasswordConfig =
    let defaults =
        {
            ZxcvbnList = []
            MinScore = PasswordScore.SoSo
            PasswordStrength = PasswordStrengthConfig.defaults
        }